import React from "react";
import "../Styles/Projects.css";
// import NextBuy from "../Images/nextbuy.png";
// import ArtUnltd from "../Images/art_unltd.png";
// import PlanetR from "../Images/planet_r.png";
// import Azeemo from "../Images/azeemo_tcg.png";
// import Popmart from "../Images/azeemo_popmart.png";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faGithub } from "@fortawesome/free-brands-svg-icons";

function Projects({ all_projects }) {
  // console.log(all_projects)

  return (
    <div className="Projects">
      <div className="title">Projects</div>
      <div className="all-projects">
        {/* <div className="project-card">
          <a href="https://azeemo.netlify.app/">
            <picture>
              <img
                className="proj-img"
                src={Azeemo}
                width={1150}
                height={700}
              ></img>
            </picture>
          </a>
          <div className="proj-info">
            <a href="https://azeemo.netlify.app/">
              <div className="proj-name">
                AzeemoTCG <span className="subtitle">(site & logo design)</span>
              </div>
            </a>
            <div className="proj-github">
              <a href="https://github.com/r-shahid/azeemo">
                <FontAwesomeIcon icon={faGithub} />
              </a>
            </div>
          </div>
        </div>
        <div className="project-card">
          <a href="https://azeemotcg-popmart.netlify.app/">
            <picture>
              <img
                className="proj-img"
                src={Popmart}
                width={1150}
                height={700}
              ></img>
            </picture>
          </a>
          <div className="proj-info">
            <a href="https://azeemotcg-popmart.netlify.app/">
              <div className="proj-name">Popmart Inventory</div>
            </a>
            <div className="proj-github">
              <a href="https://github.com/r-shahid/popmart-stock">
                <FontAwesomeIcon icon={faGithub} />
              </a>
            </div>
          </div>
        </div>
        <div className="project-card">
          <a
            className="proj-img-link"
            href="https://nextbuy-n7uf.onrender.com/"
          >
            <picture>
              <img
                className="proj-img"
                src={NextBuy}
                width={1150}
                height={700}
              ></img>
            </picture>
          </a>
          <div className="proj-info">
            <a href="https://nextbuy-n7uf.onrender.com/">
              <div className="proj-name">NextBuy</div>
            </a>
            <div className="proj-github">
              <a href="https://github.com/r-shahid/nextbuy">
                <FontAwesomeIcon icon={faGithub} />
              </a>
            </div>
          </div>
        </div>
        <div className="project-card">
          <a href="https://art-unlimited.netlify.app/">
            <picture>
              <img
                className="proj-img"
                src={ArtUnltd}
                width={1150}
                height={700}
              ></img>
            </picture>
          </a>
          <div className="proj-info">
            <a href="https://art-unlimited.netlify.app/">
              <div className="proj-name">Art Unlimited</div>
            </a>
            <div className="proj-github">
              <a href="https://github.com/r-shahid/art-app/">
                <FontAwesomeIcon icon={faGithub} />
              </a>
            </div>
          </div>
        </div> */}
        {all_projects.toReversed().map((project) => {
          console.log(project);
          return (
            <div className="project-card" id={project.key}>
              <a href={project.siteLink} target="_blank" rel="noreferrer">
                <picture>
                  <img
                    className="proj-img"
                    src={project.img}
                    alt={`${project.title} thumbnail`}
                  />
                </picture>
              </a>
              <div className="proj-info">
                <a href={project.siteLink} rel="noreferrer" target="_blank">
                  <div className="proj-name">{project.title}</div>
                </a>
                <div className="proj-github" >
                  <a href={project.gitLink} rel="noreferrer" target="_blank">
                    <FontAwesomeIcon icon={faGithub} />
                  </a>
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}

export default Projects;
